import { useState } from 'react';

const useDropDown = ({ courses = [] }) => {
  const [search, setSearch] = useState('');
  const [terminal, setTerminal] = useState('');
  const [category, setCategory] = useState('');

  const coursesFilters = courses.filter(field => {
    const isMatch = field[0]?.toLowerCase().startsWith(search.toLowerCase());
    const isTerminal = field[1]?.includes(terminal) || terminal === '';
    const isCategory = field[3] === category || category === '';
    if (isMatch && isTerminal && isCategory) {
      return field;
    }
    return null;
  });

  return {
    setSearch,
    setTerminal,
    setCategory,
    coursesFilters,
  };
};

export default useDropDown;
